import angular from 'angular';
import {
  loaderService,
  ssDialogService,
} from 'app/services';
import {
  actionIcon,
  alerts,
  confirmDialog,
} from 'app/components/global';
import DemoListItemController from './demo-list-item.controller';
import demoListItemDirective from './demo-list-item.directive';
import editNavDemoDialog from '../dialog.editNavDemoDialog';

export default angular.module('app.components.demo.demoListItem', [
  actionIcon,
  loaderService,
  ssDialogService,
  editNavDemoDialog,
  alerts,
  confirmDialog
])
  .directive('demoListItem', demoListItemDirective)
  .controller('DemoListItemController', DemoListItemController)
  .name;

console.log('app.components.demo.demoListItem created');
